import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight, ExternalLink, BarChart3, Users, Calendar, ArrowUpRight } from 'lucide-react';
export const PortfolioPage = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const categories = [{
    id: 'all',
    name: 'All'
  }, {
    id: 'tech',
    name: 'Technology'
  }, {
    id: 'finance',
    name: 'Finance'
  }, {
    id: 'healthcare',
    name: 'Healthcare'
  }, {
    id: 'real-estate',
    name: 'Real Estate'
  }, {
    id: 'energy',
    name: 'Energy'
  }, {
    id: 'consumer',
    name: 'Consumer'
  }];
  const portfolioItems = [{
    name: 'NexGen Technologies',
    category: 'tech',
    description: 'AI-powered enterprise software solutions',
    longDescription: 'NexGen Technologies develops cutting-edge AI solutions for enterprise clients, helping them automate processes, gain insights from data, and improve decision-making. Their flagship product suite includes modules for predictive analytics, natural language processing, and machine learning operations.',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    yearInvested: 2021,
    location: 'San Francisco, CA',
    stage: 'Growth',
    keyMetrics: ['85% YoY revenue growth', '120+ enterprise clients', '$25M ARR']
  }, {
    name: 'FinCore Systems',
    category: 'finance',
    description: 'Digital banking infrastructure provider',
    longDescription: 'FinCore Systems provides API-first banking infrastructure that enables financial institutions and fintech companies to build, launch, and scale digital banking products. Their platform handles everything from account opening and KYC to transaction processing and regulatory compliance.',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    yearInvested: 2019,
    location: 'New York, NY',
    stage: 'Series C',
    keyMetrics: ['$2B+ transaction volume', '40+ financial institutions', '15M+ end users']
  }, {
    name: 'MediScan',
    category: 'healthcare',
    description: 'Advanced medical imaging solutions',
    longDescription: 'MediScan develops AI-enhanced medical imaging technology that helps radiologists detect abnormalities with greater accuracy and efficiency. Their software integrates with existing hospital systems and uses deep learning algorithms to analyze X-rays, MRIs, and CT scans.',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    yearInvested: 2020,
    location: 'Boston, MA',
    stage: 'Series B',
    keyMetrics: ['98.5% diagnostic accuracy', '200+ hospital partnerships', '30% reduction in diagnosis time']
  }, {
    name: 'Urban Spaces',
    category: 'real-estate',
    description: 'Smart commercial property development',
    longDescription: 'Urban Spaces develops and manages commercial real estate properties with a focus on sustainability and smart building technology. Their portfolio includes office spaces, retail centers, and mixed-use developments in major metropolitan areas.',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    yearInvested: 2018,
    location: 'Chicago, IL',
    stage: 'Growth',
    keyMetrics: ['1.2M sq ft under management', '95% occupancy rate', 'LEED certification across 80% of properties']
  }, {
    name: 'DataSphere',
    category: 'tech',
    description: 'Cloud data management platform',
    longDescription: 'DataSphere offers a comprehensive cloud data management platform that helps enterprises organize, protect, and derive value from their data. Their solutions include data governance, backup and recovery, and analytics capabilities.',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2068&q=80',
    yearInvested: 2022,
    location: 'Seattle, WA',
    stage: 'Series A',
    keyMetrics: ['3 petabytes of data managed', '60+ enterprise customers', '99.99% uptime']
  }, {
    name: 'HealthConnect',
    category: 'healthcare',
    description: 'Telehealth service provider',
    longDescription: 'HealthConnect provides a comprehensive telehealth platform that connects patients with healthcare providers for virtual consultations. Their technology includes scheduling, video conferencing, electronic health records, and billing integration.',
    image: 'https://images.unsplash.com/photo-1504439468489-c8920d796a29?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80',
    yearInvested: 2020,
    location: 'Austin, TX',
    stage: 'Series B',
    keyMetrics: ['500,000+ patient consultations', '2,000+ healthcare providers', '4.8/5 patient satisfaction']
  }, {
    name: 'SolarPeak',
    category: 'energy',
    description: 'Residential solar energy solutions',
    longDescription: 'SolarPeak designs, installs, and finances solar energy systems for residential properties. Their innovative financing models and efficient installation processes make solar energy accessible to a broader range of homeowners.',
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80',
    yearInvested: 2019,
    location: 'Denver, CO',
    stage: 'Growth',
    keyMetrics: ['15,000+ installations', '75MW installed capacity', '40% YoY growth']
  }, {
    name: 'GourmetBox',
    category: 'consumer',
    description: 'Premium meal kit delivery service',
    longDescription: 'GourmetBox delivers premium meal kits featuring chef-designed recipes and high-quality ingredients. Their subscription service caters to various dietary preferences and includes options for special occasions and entertaining.',
    image: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80',
    yearInvested: 2021,
    location: 'Portland, OR',
    stage: 'Series A',
    keyMetrics: ['50,000+ active subscribers', '90% retention rate', '$35M annual revenue']
  }, {
    name: 'SecureChain',
    category: 'finance',
    description: 'Blockchain security solutions',
    longDescription: 'SecureChain develops security solutions for blockchain applications and cryptocurrency exchanges. Their products include threat detection systems, secure wallet technology, and compliance tools for the digital asset industry.',
    image: 'https://images.unsplash.com/photo-1639322537228-f710d846310a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2232&q=80',
    yearInvested: 2022,
    location: 'Miami, FL',
    stage: 'Series B',
    keyMetrics: ['$50B+ in assets protected', '30+ exchange partnerships', 'Zero security breaches']
  }];
  const filteredItems = activeFilter === 'all' ? portfolioItems : portfolioItems.filter(item => item.category === activeFilter);
  return <div className="min-h-screen flex flex-col" data-id="element-599">
      <Header data-id="element-600" />
      <main className="flex-grow pt-20" data-id="element-601">
        {/* Hero Banner */}
        <section className="relative bg-[#0a2351] text-white" data-id="element-602">
          <div className="absolute inset-0 z-0 opacity-20" data-id="element-603">
            <img src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80" alt="Portfolio background" className="w-full h-full object-cover" data-id="element-604" />
          </div>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-10" data-id="element-605">
            <div className="max-w-3xl" data-id="element-606">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-607">
                Our Portfolio
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-2xl" data-id="element-608">
                Partnering with exceptional companies across industries to drive
                innovation and growth
              </p>
              <nav className="flex" aria-label="Breadcrumb" data-id="element-609">
                <ol className="inline-flex items-center space-x-1 md:space-x-3" data-id="element-610">
                  <li className="inline-flex items-center" data-id="element-611">
                    <a href="/" className="text-gray-300 hover:text-white" data-id="element-612">
                      Home
                    </a>
                  </li>
                  <li data-id="element-613">
                    <div className="flex items-center" data-id="element-614">
                      <ChevronRight className="w-4 h-4 text-gray-300" data-id="element-615" />
                      <span className="ml-1 text-white md:ml-2" data-id="element-616">Portfolio</span>
                    </div>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="h-16 bg-gradient-to-b from-[#0a2351] to-white opacity-20" data-id="element-617"></div>
        </section>
        {/* Portfolio Overview */}
        <section className="py-16 bg-white" data-id="element-618">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-619">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-620">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-621">
                Investment Portfolio
              </h2>
              <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-622"></div>
              <p className="text-xl text-gray-600" data-id="element-623">
                Our diverse portfolio spans multiple industries and stages,
                united by a commitment to innovation and sustainable growth
              </p>
            </div>
            <div className="flex flex-wrap justify-center mb-12 gap-2" data-id="element-624">
              {categories.map(category => <button key={category.id} onClick={() => setActiveFilter(category.id)} className={`px-5 py-2 rounded-full text-sm font-medium transition-colors duration-300 ${activeFilter === category.id ? 'bg-[#0a2351] text-white' : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'}`} data-id="element-625">
                  {category.name}
                </button>)}
            </div>
            {/* Portfolio Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-626">
              {filteredItems.map((item, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-100 flex flex-col" data-id="element-627">
                  <div className="h-48 overflow-hidden relative" data-id="element-628">
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500" data-id="element-629" />
                    <div className="absolute top-0 right-0 bg-[#0a2351] text-white px-3 py-1 text-sm font-medium" data-id="element-630">
                      {item.stage}
                    </div>
                  </div>
                  <div className="p-6 flex-grow" data-id="element-631">
                    <div className="flex justify-between items-start mb-2" data-id="element-632">
                      <h3 className="text-xl font-semibold text-[#0a2351]" data-id="element-633">
                        {item.name}
                      </h3>
                      <span className="inline-block px-3 py-1 bg-gray-100 text-gray-600 rounded-full text-xs font-medium" data-id="element-634">
                        {categories.find(cat => cat.id === item.category)?.name}
                      </span>
                    </div>
                    <p className="text-gray-600 mb-4" data-id="element-635">{item.longDescription}</p>
                    <div className="grid grid-cols-2 gap-4 mt-4" data-id="element-636">
                      <div className="flex items-center" data-id="element-637">
                        <Calendar size={16} className="text-[#38b2ac] mr-2" data-id="element-638" />
                        <span className="text-sm text-gray-600" data-id="element-639">
                          Invested: {item.yearInvested}
                        </span>
                      </div>
                      <div className="flex items-center" data-id="element-640">
                        <Users size={16} className="text-[#38b2ac] mr-2" data-id="element-641" />
                        <span className="text-sm text-gray-600" data-id="element-642">
                          {item.location}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="px-6 pb-6" data-id="element-643">
                    <div className="mt-4" data-id="element-644">
                      <h4 className="text-sm font-semibold text-gray-700 mb-2 flex items-center" data-id="element-645">
                        <BarChart3 size={16} className="text-[#38b2ac] mr-2" data-id="element-646" />
                        Key Metrics
                      </h4>
                      <ul className="list-disc list-inside text-sm text-gray-600 pl-2" data-id="element-647">
                        {item.keyMetrics.map((metric, idx) => <li key={idx} data-id="element-648">{metric}</li>)}
                      </ul>
                    </div>
                    <button className="mt-6 w-full flex items-center justify-center px-4 py-2 border border-[#0a2351] text-[#0a2351] rounded-md hover:bg-[#0a2351] hover:text-white transition-colors duration-300" data-id="element-649">
                      <span data-id="element-650">View Details</span>
                      <ArrowUpRight size={16} className="ml-2" data-id="element-651" />
                    </button>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Portfolio Stats */}
        <section className="py-16 bg-gray-50" data-id="element-652">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-653">
            <div className="max-w-5xl mx-auto" data-id="element-654">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-655">
                <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-656">
                  <div className="text-[#38b2ac] text-4xl font-bold mb-2" data-id="element-657">
                    $250M+
                  </div>
                  <div className="text-gray-600" data-id="element-658">Capital Deployed</div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-659">
                  <div className="text-[#38b2ac] text-4xl font-bold mb-2" data-id="element-660">
                    35+
                  </div>
                  <div className="text-gray-600" data-id="element-661">Portfolio Companies</div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-662">
                  <div className="text-[#38b2ac] text-4xl font-bold mb-2" data-id="element-663">
                    12
                  </div>
                  <div className="text-gray-600" data-id="element-664">Successful Exits</div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-665">
                  <div className="text-[#38b2ac] text-4xl font-bold mb-2" data-id="element-666">
                    7
                  </div>
                  <div className="text-gray-600" data-id="element-667">Industries</div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* CTA Section */}
        <section className="py-16 bg-[#0a2351]" data-id="element-668">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-669">
            <div className="max-w-4xl mx-auto text-center" data-id="element-670">
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-671">
                Join Our Portfolio
              </h2>
              <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto" data-id="element-672">
                Are you building an exceptional company? We're always looking
                for visionary entrepreneurs to partner with.
              </p>
              <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-673">
                <a href="/contact" className="inline-block bg-[#38b2ac] hover:bg-[#319795] text-white font-medium py-3 px-8 rounded-md transition-colors duration-300" data-id="element-674">
                  Contact Our Investment Team
                </a>
                <a href="/investments" className="inline-block bg-transparent border-2 border-white text-white font-medium py-3 px-8 rounded-md hover:bg-white hover:text-[#0a2351] transition-colors duration-300" data-id="element-675">
                  Learn About Our Approach
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-676" />
    </div>;
};